import servicio from "./servicio";

export default {
    servicio
}